<div class="clare-dialog">
    <div *ngIf="isCloseShown" class="close-icon">
        <button mat-icon-button aria-label="Example icon button with a vertical three dot icon" tabindex="-1" (click)="onClose()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-icon *ngIf="data.icon" class="center-text" [svgIcon]="data.icon">{{ data.icon }}</mat-icon>
    <h1 *ngIf="data.title" mat-dialog-title class="center-text dialog-title">{{ data.title }}</h1>
    <div mat-dialog-content class="center-text dialog-content" *ngIf="!data.loading; else loadingContent">
        <p [class]="data.messageStyleClass" [innerHTML]="data.message"></p>
        <div *ngIf="data.messageHint">
            <p class="msg-hint">{{ data.messageHint }}</p>
        </div>
        <span *ngIf="checkProperties() as props">
            <p *ngFor="let key of props">{{ key | uppercase }}: {{ data.properties[key] }}</p>
        </span>
    </div>
    <div *ngIf="!data.loading && data.requiredInfo">
        <generic-input-container
            *ngFor="let info of data.requiredInfo"
            [metadataInputs]="info"
            (relayEmitter)="onParameterUpdate($event)"
            hideSubmit="true"
        ></generic-input-container>
    </div>
    <div mat-dialog-actions class="center-text clare-dialog-actions" *ngIf="data && data.buttons && !data.loading">
        <ng-container *ngFor="let button of data.buttons">
            <button
                *ngIf="button.buttonColor === 'primary'; else secondaryButton"
                mat-raised-button
                class="dialog-action-button"
                [class]="button.styleClass"
                [color]="button.buttonColor"
                (click)="handleEvent(button.method)"
            >
                {{ button.text }}
            </button>
            <ng-template #secondaryButton>
                <button
                    *ngIf="button.buttonColor === 'secondary'; else otherButton"
                    mat-stroked-button
                    class="dialog-action-button"
                    [class]="button.styleClass"
                    [color]="button.buttonColor"
                    (click)="handleEvent(button.method)"
                >
                    {{ button.text }}
                </button>
                <ng-template #otherButton>
                    <button
                        mat-stroked-button
                        class="dialog-action-button"
                        [class]="button.styleClass"
                        [color]="button.buttonColor"
                        (click)="handleEvent(button.method)"
                    >
                        {{ button.text }}
                    </button>
                </ng-template>
            </ng-template>
        </ng-container>
    </div>
    <ng-template #loadingContent>
        <div mat-dialog-content>
            <clare-spinner [text]="data.loadingMessage"></clare-spinner>
        </div>
    </ng-template>
</div>
